import type { CustomerInfoFormValues } from '@t/checkout.types';

export const textFieldSx = {
  '& .MuiOutlinedInput-input::placeholder': { fontSize: '16px', fontWeight: 400, lineHeight: '100%' },
  '& .MuiOutlinedInput-root': { '& fieldset': { borderRadius: '6px' } },
};

export const noAutofillSx = {
  ...textFieldSx,
  '& .MuiOutlinedInput-input:-webkit-autofill': {
    WebkitBoxShadow: '0 0 0 100px #fff inset',
    WebkitTextFillColor: 'inherit',
  },
};

export const INITIAL_VALUES: CustomerInfoFormValues = {
  titleId: '',
  firstName: '',
  middleName: '',
  lastName: '',
  email: '',
  confirmEmail: '',
  dateOfBirth: '',
  howDidYouHearAboutUs: '',
  howDidYouHearAboutUsOther: '',
  primaryPhoneNumber: '',
  primaryPhoneNumberType: '',
  password: '',
  confirmPassword: '',
  billDelivery: 'email',
  useSameAddress: true,
  billingStreet: '',
  billingUnit: '',
  billingCity: '',
  billingProvince: '',
  billingPostalCode: '',
  billingCountry: '',
};

export const HOW_DID_YOU_HEAR_OPTIONS = [
  {
    label: 'Referral from friend, family, co-worker, landlord etc',
    value: 'Referral from friend, family, co-worker, landlord etc',
  },
  { label: 'Searched online', value: 'Searched online' },
  { label: 'Saw an online ad', value: 'Saw an online ad' },
  {
    label: 'Outdoor Advertising - Billboards, transit, skytrain',
    value: 'Outdoor Advertising - Billboards, transit, skytrain',
  },
  { label: 'Postcards', value: 'Postcards' },
  { label: 'Returning Customer', value: 'Returning Customer' },
  { label: 'Online forum like Reddit', value: 'Online forum like Reddit' },
  { label: 'Asked ChatGPT', value: 'Asked ChatGPT' },
  { label: 'Social Media - Facebook, Instagram, X', value: 'Social Media - Facebook, Instagram, X' },
  { label: 'Saw Poster/Flyer/Brochure in building', value: 'Saw Poster/Flyer/Brochure in building' },
  { label: 'Sales Event in my building', value: 'Sales Event in my building' },
  { label: 'Saw Novus Vehicle', value: 'Saw Novus Vehicle' },
  { label: 'Visited/Saw the Store in Yaletown', value: 'Visited/Saw the Store in Yaletown' },
  { label: 'Other', value: 'Other' },
];

export const PROVINCE_OPTIONS = [
  { label: 'Alberta', value: 'AB' },
  { label: 'British Columbia', value: 'BC' },
  { label: 'Manitoba', value: 'MB' },
  { label: 'New Brunswick', value: 'NB' },
  { label: 'Newfoundland and Labrador', value: 'NL' },
  { label: 'Nova Scotia', value: 'NS' },
  { label: 'Northwest Territories', value: 'NT' },
  { label: 'Nunavut', value: 'NU' },
  { label: 'Ontario', value: 'ON' },
  { label: 'Prince Edward Island', value: 'PE' },
  { label: 'Quebec', value: 'QC' },
  { label: 'Saskatchewan', value: 'SK' },
  { label: 'Yukon', value: 'YT' },
];

export const COUNTRY_OPTIONS = [
  { label: 'Canada', value: 'CA' },
  { label: 'United States', value: 'US' },
];

export interface DobBounds {
  minDate: string;
  maxDate: string;
  minBirthDate: Date;
  minDateValue: Date;
  today: Date;
}

export const getDobBounds = (): DobBounds => {
  const today = new Date();
  const minDateValue = new Date(1900, 0, 1);
  const minBirthDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
  return {
    today,
    minDateValue,
    minBirthDate,
    maxDate: today.toISOString().split('T')[0],
    minDate: minDateValue.toISOString().split('T')[0],
  };
};
